export interface Article {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  cover: string;
  date: string;
  readTime: string;
  author: string;
  tags: string[];
  content: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    title: "用一杯快乐水，打开追更的正确方式",
    excerpt: "从选对口味到搭配零食，一篇教你如何把追更变成每天最放松的快乐时刻。",
    category: "追更指南",
    cover: "https://readdy.ai/api/search-image?query=A%20cozy%20reading%20scene%20with%20a%20person%20reading%20a%20comic%20on%20a%20couch%2C%20an%20ice%20cold%20cola%20glass%20with%20bubbles%20and%20snacks%20beside%2C%20warm%20cream%20and%20caramel%20tones%2C%20relaxed%20lifestyle%20photography%20style%2C%20soft%20warm%20lighting&width=1600&height=900&seq=article-cola-reading&orientation=landscape",
    date: "2026-08-10",
    readTime: "5 分钟",
    author: "快乐水编辑",
    tags: ["追更", "快乐水", "放松"],
    content: [
      "追更漫画最讲究的，从来不是速度，而是氛围。一杯冰镇的快乐水放在手边，屏幕里的热血与气泡一起升腾，这才是属于你的专属放松时刻。",
      "选口味其实很有讲究。追热血漫的时候，经典原味最配那些燃到不行的名场面；追治愈日常漫时，更清爽的气泡款反而能让心情跟着慢下来。快乐水组合的意义，就是让每一种情绪都有对应的一口。",
      "零食搭配也不能马虎。薯片配搞笑漫，边笑边吃毫无压力；坚果配悬疑漫，烧脑的时候刚好补充体力。肥宅快乐套餐的精髓，就是让人怎么舒服怎么来。",
      "最后，记得把追更安排在真正属于自己的时间里。无论是午休摸鱼，还是周末窝在沙发里，只要手里有快乐水、屏幕里有好故事，再普通的一天也能闪闪发光。",
    ],
  },
  {
    id: 2,
    title: "肥宅快乐套餐测评：追更配什么零食最香",
    excerpt: "实测薯片、坚果、炸鸡和快乐水的搭配，帮你找到周末放松摸鱼的最佳组合。",
    category: "快乐套餐",
    cover: "https://readdy.ai/api/search-image?query=A%20food%20flat%20lay%20of%20a%20happiness%20combo%20with%20cola%20chips%20nuts%20and%20fried%20chicken%20on%20a%20warm%20wooden%20table%2C%20cozy%20warm%20cream%20and%20caramel%20tones%2C%20appetizing%20food%20photography%20with%20soft%20warm%20lighting&width=1600&height=900&seq=article-snack-set&orientation=landscape",
    date: "2026-08-05",
    readTime: "6 分钟",
    author: "零食侦探",
    tags: ["零食", "套餐", "测评"],
    content: [
      "追更最快乐的瞬间，就是打开新一话的同时咬下第一口零食。本期我们实测了几组人气搭配，帮你找到最香的那一套快乐水组合。",
      "先说薯片。它的咸香和快乐水的甜恰到好处地互补，是搞笑漫和日常漫的百搭之选。注意别选太油太咸的，容易口渴打断节奏。",
      "坚果更适合悬疑和烧脑题材。一颗颗咀嚼的节奏刚好和剧情推进同步，让你全程保持专注，又不会太占手。",
      "炸鸡算是豪华版选择。周末摸鱼的时候，一份热腾腾的炸鸡配一杯冰可乐，幸福感直接拉满。不过热量略高，偶尔犒劳自己刚刚好。",
      "最后提醒：快乐水组合的关键是量要适中，追更别贪杯贪嘴。享受美食与故事，让每个周末都值得期待。",
    ],
  },
  {
    id: 3,
    title: "周末摸鱼指南：快乐水与漫画的黄金组合",
    excerpt: "工作一周累了，周末就该好好犒劳自己。这份摸鱼放松清单请查收。",
    category: "生活灵感",
    cover: "https://readdy.ai/api/search-image?query=A%20relaxed%20weekend%20scene%20of%20someone%20lounging%20on%20a%20couch%20with%20a%20comic%20and%20a%20glass%20of%20cola%20with%20ice%2C%20cozy%20afternoon%20light%2C%20warm%20cream%20and%20caramel%20tones%2C%20calm%20and%20joyful%20lifestyle%20photography&width=1600&height=900&seq=article-weekend&orientation=landscape",
    date: "2026-07-28",
    readTime: "4 分钟",
    author: "摸鱼达人",
    tags: ["周末", "放松", "指南"],
    content: [
      "一周的工作结束，周末是属于自己的时间。最好的放松方式，往往是简单到不需要思考——一杯快乐水，一部好漫画，就能让整个下午慢下来。",
      "周六上午，适合来点轻松治愈的日常漫，配一杯冰镇气泡快乐水，让心情随着气泡一起轻盈起来。",
      "周六下午，可以上点热血番。燃向剧情配上经典原味，就像给自己加满能量，为接下来的假期蓄力。",
      "周日晚上，建议选择节奏舒缓的治愈漫收尾，搭配一小份喜欢的零食。肥宅快乐套餐在这里的意义，不是放纵，而是给自己一场温柔的告别周末仪式。",
      "记住，放松不是浪费时间。会摸鱼、会快乐，才能更好地迎接新的一周。",
    ],
  },
  {
    id: 4,
    title: "热血漫推荐：这几部让你一口气追完",
    excerpt: "从校园热血到异世界冒险，编辑部精选四部让人欲罢不能的燃番。",
    category: "漫画推荐",
    cover: "https://readdy.ai/api/search-image?query=A%20collection%20of%20dynamic%20hot%20blooded%20manga%20covers%20arranged%20together%20with%20warm%20orange%20and%20caramel%20red%20tones%2C%20action%20packed%20hero%20characters%2C%20energetic%20and%20bold%20cartoon%20illustration%20style&width=1600&height=900&seq=article-hot-manga&orientation=landscape",
    date: "2026-07-20",
    readTime: "7 分钟",
    author: "追更老司机",
    tags: ["热血", "推荐", "燃番"],
    content: [
      "如果你想找几部能一口气追完、看得血脉偾张的作品，这份热血漫清单值得收进你的追更计划。每一部都搭配好了一杯快乐水，随时可以开看。",
      "第一部是《可乐少年》。少年用一杯快乐水唤醒潜藏力量的热血成长故事，节奏明快、打斗过瘾，特别适合一口气看到最新话。",
      "第二部《气泡异世界》走的是异世界冒险路线。世界观想象力十足，画面色彩温暖，追更配气泡快乐水，体验感直接翻倍。",
      "第三部《冰可乐星球》融合了科幻与冒险，在冰封的快乐水星球上展开拯救之旅，设定新颖，越看越上头。",
      "最后是《元气苏打》这样的治愈系热血，看似温柔实则后劲十足。看完它，你会相信简单与坚持本身就足够耀眼。",
    ],
  },
  {
    id: 5,
    title: "深夜追更小贴士：快乐水这样喝更解压",
    excerpt: "加班到深夜想放松？这几条追更小贴士让快乐水成为你的解压神器。",
    category: "生活灵感",
    cover: "https://readdy.ai/api/search-image?query=A%20moody%20late%20night%20reading%20scene%20with%20a%20dim%20warm%20lamp%20a%20comic%20book%20and%20a%20frosted%20glass%20of%20cola%20with%20ice%2C%20warm%20caramel%20and%20cream%20tones%2C%20cozy%20and%20relaxing%20atmosphere&width=1600&height=900&seq=article-night-reading&orientation=landscape",
    date: "2026-07-12",
    readTime: "5 分钟",
    author: "深夜编辑",
    tags: ["深夜", "解压", "贴士"],
    content: [
      "结束忙碌的一天，深夜是许多人的专属放松时间。一盏暖灯、一本漫画、一杯快乐水，就足以让疲惫悄悄溜走。",
      "深夜追更，温度很关键。冰镇快乐水配热血番最提神，但如果是睡前助眠，建议选择常温或稍微回温的气泡款，避免刺激影响睡眠。",
      "灯光也很重要。太亮的顶灯容易让眼睛疲劳，一盏暖黄色的床头灯反而更能营造沉浸感，让漫画的线条和色彩都更温柔。",
      "如果追更到精彩处舍不得停，记得给自己设个小目标：看完这一话就好好休息。快乐水可以续杯，但好睡眠才是一天的底气。",
      "愿每个深夜，你都能被喜欢的故事和一罐快乐水温柔以待。",
    ],
  },
];